module.exports = __webpack_public_path__ + "media/images/application/template/arrow-left-c9709e33d539a874745cdf5747aa39d1.svg";